/** Roles that hold a "Planning in the past" default. Values are the API names. */
export enum PlanningInThePastRole {
  MANAGER = 'Manager',
  SUPER_ADMIN = 'SuperAdmin',
  API_USER = 'ApiUser',
}
